import {library, icon as faIcon, dom, IconPrefix, findIconDefinition, IconName} from '@thinkeleven/fontawesome-svg/core';

// Import icons from the FontAwesome package to add to the NorthRock subset.
// This helps immensely reduce the download size by not importing all of the nearly 8,000 FA icons.
// Find icons at https://fontawesome.com/v5/search
// Be sure to add them to the library in the Icon.load() method.
import {faLongArrowRight} from '@thinkeleven/fontawesome-svg/regular/faLongArrowRight';
import {faArrowToBottom} from '@thinkeleven/fontawesome-svg/regular/faArrowToBottom';
import {faExternalLink} from '@thinkeleven/fontawesome-svg/regular/faExternalLink';
import {faBars} from '@thinkeleven/fontawesome-svg/regular/faBars';

// Chevrons
import {faChevronDown} from '@thinkeleven/fontawesome-svg/regular/faChevronDown';
import {faChevronLeft} from '@thinkeleven/fontawesome-svg/regular/faChevronLeft';
import {faChevronRight} from '@thinkeleven/fontawesome-svg/regular/faChevronRight';

// Social icons
import {faLinkedinIn} from '@thinkeleven/fontawesome-svg/brands/faLinkedinIn';
import {faFacebook} from '@thinkeleven/fontawesome-svg/brands/faFacebook';
import {faTwitter} from '@thinkeleven/fontawesome-svg/brands/faTwitter';
import {faInstagram} from '@thinkeleven/fontawesome-svg/brands/faInstagram';

export default class Icon {
	public static create(iconName: IconName, prefix: IconPrefix = 'far'): Element {
		const def = findIconDefinition({prefix, iconName});
		const icon = faIcon(def);
		return icon.node[0];
	}

	public static load(): void {
		library.add(
			faLongArrowRight,
			faArrowToBottom,
			faExternalLink,
			faBars,

			// Chevrons
			faChevronDown,
			faChevronLeft,
			faChevronRight,

			// Social
			faLinkedinIn,
			faFacebook,
			faTwitter,
			faInstagram
		);
		dom.watch();
	}
}
